import React, { useContext } from "react";
import moment from "moment";
import { ShipmentContext } from "../../contexts/ShipmentContext.jsx";
import { translate } from "../../../utility/strings.js";

const ShipmentHistory = () => {

  let { shipment } = useContext(ShipmentContext);

  let dates = [];
  shipment?.events?.forEach((value, key) => {
    const eventDate = moment(value.date).format("M/DD/YYYY");
    const date = dates.find(date => date.date === eventDate);
    if (date) {
      date.events.push(value);
    } else {
      dates.push({date: eventDate, dateTime:value.date, events: [value]});
    }
  });

  dates.sort((a, b) => {
    return moment(a.dateTime).isBefore(b.dateTime) ? 1 : -1;
  });

  if( !shipment?.events || shipment?.events?.length === 0 ){
    return null;
  }

  return (
    <div className="shipment-history container container--narrow my-10">
      <details aria-expanded="false" is="accordion-disclosure" class="group" open>
        <summary className="flex justify-between pb-3 border-b">
          <span className="h4">{translate("shipment_tracking.shipment_history", "Shipment History")}</span>
          <span className="circle-chevron group-hover:colors group-expanded:colors group-expanded:rotate">
            <svg role="presentation" focusable="false" width="8" height="6" className="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
              <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
          </span>
        </summary>
        <div className="py-3 border-b text-lg">
          {dates.map(date => {
            date.events.sort((a, b) => {
              return moment(a.date).isBefore(b.date) ? 1 : -1;
            });
            return <div className="shipment-history__date mb-8">
              <span class="font-bold mb-3 block">{date.date}</span>
              <ul className="shipment-history__events event-timeline">
                {date.events.map(event => {
                  return <li className="shipment-history__event">
                    <div className="flex wrap sm:gap-8">
                      {event.description ? <div className="w-full sm:w-1/3">{event.description}</div> : null}
                      {event.address && event.address.city ? <div className="w-full sm:w-1/3">{`${event.address.city ? event.address.city + ', ' : ''}${event.address.state || ''} ${event.address.zip || ''}`}</div> : null}
                      {event.date ? <div className="w-full sm:w-1/4 sm:text-right">{moment(event.date).format('h:mm a')}</div> : null}
                    </div>
                  </li>
                })}
              </ul>
            </div>
          })}
        </div>
      </details>
    </div>
  );

}

export default ShipmentHistory;
